import Swiper from 'swiper';

import { Navigation } from 'swiper/modules';

class BlockSliderMedias {
    constructor() {
        this._init();
    }

    _init() {
        new Swiper('.slider-medias__swiper', {
            direction: 'horizontal',
            modules: [Navigation],
            slidesPerView: 1,
            spaceBetween: 20,
            grabCursor: true,
            preventInteractionOnTransition: true,
            navigation: {
                enabled: true,
                nextEl: '.slider-medias__swiper-button--next',
                prevEl: '.slider-medias__swiper-button--prev',
            },
            breakpoints: {
                640: {
                    slidesPerView: 1,
                    spaceBetween: 24,
                },
                1025: {
                    slidesPerView: 1,
                    spaceBetween: 24,
                },
            },
        });
    }
}

export const blockSliderMedias = new BlockSliderMedias();